import { render, staticRenderFns } from "./company-lists-item-placeholder.vue?vue&type=template&id=29bfdd61&scoped=true&"
import script from "./company-lists-item-placeholder.vue?vue&type=script&lang=ts&"
export * from "./company-lists-item-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./company-lists-item-placeholder.vue?vue&type=style&index=0&id=29bfdd61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfdd61",
  null
  
)

export default component.exports